import React from 'react';
import PropTypes from 'prop-types';

const TextInputField = ({
  label, name, value, onChange, type,
}) => (
  <div className="flex flex-wrap mx-3 w-5/12">
    <div className="flex flex-col w-full px-3 lg:mb-6">
      <label
        htmlFor={name}
        className="text-gray-400 text-sm mb-2"
      >
        {label}
        <span className="text-red-500">*</span>
      </label>

      <input
        className="border-2 border-gray-500 bg-gray-300 h-10 px-5 rounded-md text-sm text-gray-500 leading-tight focus:outline-none focus:bg-white"
        type={type}
        id="hazard"
        name="occurrence"
        placeholder={label}
        onChange={onChange}
        value={value}
      />
    </div>
  </div>
);

export default TextInputField;

TextInputField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};
